export enum LocationType {
    RESTAURANT = "Restaurant",
}